import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { REDIRECT_AFTER_MS } from "../../constants";
import { useFormContext } from "../context/FormContext";
import { FF2EventName, trackFF2Event } from "../analytics";
import { Spinner } from "../../../Spinner";

export const RedirectToSecuredHomepage: React.FC = () => {
  const { formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.REDIRECT_SECURED_LOANS, formData);

    setTimeout(() => {
      navigate("https://forms.better.co.uk/secured-loan-application");
    }, REDIRECT_AFTER_MS);
  }, []);

  return (
    <div className="heroff2-form">
      <h2>Great news!</h2>
      <h2>
        We can help you raise additional funds. You will be redirected to our secured
        loans homepage in
        {" "}
        {REDIRECT_AFTER_MS / 1000}
        {" "}
        seconds...
      </h2>
      <Spinner />
    </div>
  );
};
